export default {
  acab: 'ACAB',
  actions: 'Acciones',
  addProduct: 'Añadir producto',
  arcPosition: 'Posición ARC',
  businessId: 'Nit de la empresa',
  businessPhone: 'Teléfono de la empresa',
  cancel: 'Cancelar',
  client: 'Cliente',
  clientReference: 'Referencia del cliente',
  clients: 'Clientes',
  clientSuccessfullyCreated: 'Cliente creado exitosamente',
  clv: 'CLV',
  codeLab: 'Código Lab',
  colimptexCode: 'Código Colimptex',
  color: 'Color',
  colors: 'Colores',
  colorSuccessfullyCreated: 'Color creado exitosamente',
  colorSuccessfullyUpdated: 'Color editado exitosamente',
  composition: 'Composición',
  contactPerson: 'Contacto',
  container: 'Container',
  containers: 'Containers',
  containerSuccessfullyCreated: 'Container creado exitosamente',
  containerSuccessfullyUpdated: 'Container editado exitosamente',
  createClient: 'Crear Cliente',
  createColor: 'Crear Color',
  createContainerType: 'Crear Tipo de Contenedor',
  createOrderDetail: 'Crear Detalle de Orden',
  createOrder: 'Crear Orden',
  createProduct: 'Crear Producto',
  createPurchase: 'Crear orden de compra',
  createPurchaseDetail: 'Crear detalle de compra',
  createSeller: 'Crear Vendedor',
  createSupplier: 'Crear Proveedor',
  created: 'creado correctamente',
  crf: 'CRF',
  csf: 'CSF',
  currency: 'Moneda',
  deleteClient: 'Eliminar Cliente',
  deletePurchase: 'Eliminar compra',
  doYouWantToDeleteThisClient: 'Realmente quieres eliminar este cliente?',
  doYouWantToDeleteThisColor: 'Realmente quieres eliminar este color?',
  doYouWantToDeleteThisContainer: 'Realmente quieres eliminar este contenedor?',
  doYouWantToDeleteThisProduct: 'Realmente quieres eliminar este producto?',
  doYouWantToDeleteThisPurchase: 'Realmente quieres eliminar esta compra?',
  doYouWantToDeleteThisSeller: 'Realmente quieres eliminar este vendedor?',
  doYouWantToDeleteThisSupplier: 'Realmente quieres eliminar este proveedor?',
  editAddedProduct: 'Editar producto agregado',
  editClient: 'Editar Cliente',
  editColor: 'Editar color',
  editContainer: 'Editar contenedor',
  editOrderDetail: 'Editar detalle de orden',
  editOrder: 'Editar orden',
  editProduct: 'Editar producto',
  editProvider: 'Editar proveedor',
  editPurchase: 'Editar compra',
  editSeller: 'Editar vendedor',
  editSupplier: 'Editar proveedor',
  email: 'Correo electrónico',
  enterDescription: 'Inserta una descripción para el usuario',
  factory: 'Fábrica',
  fca: 'FCA',
  fiber: 'Fibra',
  finalKilogramsQuantity: 'Cantidad final en kilogramos',
  finalMetersQuantity: 'Cantidad final en metros',
  finished: 'Terminado',
  hs: 'HS',
  iva: 'IVA',
  key: 'Clave',
  kilogramsMaximumCapacity: 'Máxima capacidad en kilogramos',
  label: 'Etiqueta',
  language: 'Idioma',
  loading: 'Cargando...',
  metersKilogramsQuantity: 'Cantidad en m/kg',
  mt3: 'm3',
  mustChargeBeforeCreatingItems: 'Debes recargar antes de crear elementos',
  name: 'Nombre',
  newClient: 'Nuevo Cliente',
  newColor: 'Nuevo color',
  newContainer: 'Nuevo contenedor',
  newOrderDetail: 'Nuevo detalle de orden',
  newOrder: 'Nueva orden',
  newProduct: 'Nuevo producto',
  newProvider: 'Nuevo proveedor',
  newPurchase: 'Nueva compra',
  newSeller: 'Nuevo vendedor',
  newSupplier: 'Nuevo proveedor',
  nit: 'Nit',
  noElementsRegistered: 'No hay elementos registrados',
  onlyNumbersAllowed: 'Solo se permiten números',
  paint: 'Tintura',
  performance: 'Desempeño',
  phone: 'Teléfono',
  portOccupation: 'Ocupación portuaria',
  print: 'Estampado',
  productionDate: 'Fecha de producción',
  product: 'Producto',
  products: 'Productos',
  productSuccessfullyCreated: 'Producto creado exitosamente',
  productSuccessfullyUpdated: 'Producto actualizado exitosamente',
  profileImagePath: 'Url de la imagen de perfil',
  psv: 'PSV',
  purchaseSuccessfullyCreated: 'Compra creada exitosamente',
  purchaseSuccessfullyUpdated: 'Compra actualizada exitosamente',
  pvp: 'PVP',
  referenceInChina: 'Referencia en China',
  rgb: 'RGB',
  requiredAmount: 'Cantidad requerida',
  requirement: 'Requerimiento',
  save: 'Guardar',
  search: 'Buscar',
  seller: 'Vendedor',
  sellers: 'Vendedores',
  sellerSuccessfullyCreated: 'Vendedor creado exitosamente',
  sellerSuccessfullyUpdated: 'Vendedor editado exitosamente',
  shippingDate: 'Fecha de embarque',
  shortName: 'Nombre corto',
  sku: 'SKU',
  subInvoice: 'Subfacturado',
  sublimation: 'Sublimación',
  supplier: 'Proveedor',
  suppliers: 'Proveedores',
  supplierSuccessfullyCreated: 'Proveedor creado exitosamente',
  supplierSuccessfullyUpdated: 'Proveedor editado exitosamente',
  taxesRefund: 'Devolución de impuestos',
  totalAmount: 'Cantidad total',
  trm: 'TRM',
  typeOfContainer: 'Tipo de contenedor',
  updated: 'Actualizado correctamente',
  unitMeasure: 'Unidad de medida',
  viewClient: 'Ver Cliente',
  weight: 'Peso',
  wide: 'Largo',
  withholdingTax: 'Retención en la fuente'
}
